import { registerBrick, Config, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React from 'react';
import { DataGridPro, LicenseInfo, GridToolbar } from '@mui/x-data-grid-pro';
import { ThemeProvider } from '@mui/material/styles';
import { datagridTheme } from '../shared/_theme.jsx';

export default class MissingConfigurationDocumentsBrick extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @returns {function(object): React.ReactElement}
     */
    static getReactComponent($) {
        return (props) => {
            // listen to properties
            const loading = useProperty($, 'Loading');
            let data = useProperty($, 'Data') || [];
            const sortBy = useProperty($, 'Sort By');

            console.log('MissingConfigurationData', data);

            // setup data grid, columns to display
            const licenseKey = Config.getParameter('uiappValues.datagrid_license');
            LicenseInfo.setLicenseKey(licenseKey);

            const columns = [];
            const defineColumn = (field, headerName, otherProps) => {
                const col = {
                    field,
                    headerName,
                    flex: 1,
                    resizable: false,
                    disableColumnMenu: true,
                    sortable: true,
                    filterable: true,
                    hideable: true,
                    pinnable: false,
                    ...otherProps,
                };
                columns.push(col);
                return col;
            };

            defineColumn('DocItem', 'Item');
            defineColumn('DocNo', 'Purchasing document');
            defineColumn('Bstyp', 'Category');
            defineColumn('ProcCreDate', 'Last processing date');
            defineColumn('Bukrs', 'Company Code');
            defineColumn('Ekgrp', 'Purchasing group');
            defineColumn('Ekorg', 'Purchase org.');
            defineColumn('DocDate', 'Document Date');
            defineColumn('WiCd', 'Workflow Date');

            // check if a column should be used for sorting
            let sortModel;
            const asc = true;
            if (sortBy && columns.some((c) => c.field === sortBy)) {
                sortModel = [{ field: sortBy, sort: asc ? 'asc' : 'desc' }];
            } else {
                sortModel = undefined;
            }

            // process data, add unique index prop
            if (!loading) {
                data.forEach((o, i) => {
                    o.id = i;
                });
            } else {
                data = [];
            }

            // render
            return (
                <ThemeProvider theme={datagridTheme}>
                    <DataGridPro
                        columns={columns}
                        rows={data}
                        loading={loading}
                        sortModel={sortModel}
                        editMode="row"
                        components={{ Toolbar: GridToolbar }}
                        componentsProps={{
                            toolbar: { style: { height: '40px' } }, // give enough room for the filter pad number to display entirely
                        }}
                        sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                                textOverflow: 'clip',
                                whiteSpace: 'break-spaces',
                                lineHeight: 1,
                            },
                        }}
                        scrollbarSize={17}
                    />
                </ThemeProvider>
            );
        };
    }
}

registerBrick('0189f89db5c9dddab53e', MissingConfigurationDocumentsBrick);
